export const CONTACT_TEXT = [
    `We'd love to hear from record labels, the music press, and anyone with an offer or opportunity for us to consider. Please email `,
    {
        isContact: true,
    },
    `. Thanks!`,
]
